import { fg } from '@atlassian/jira-feature-gating';

const JiraTimelineHarmonisationM3PerformanceDisabledRelayProvider = {
	get(): boolean {
		return !fg('jira_timeline_harmonisation_m3_performance');
	},
};

export default JiraTimelineHarmonisationM3PerformanceDisabledRelayProvider;
